















import { defineComponent } from "@vue/composition-api";
import { alarm } from "@/store";
export default defineComponent({
    name: "Logout",
    setup(_, { root }) {
        alarm.clearAlarmData();
        root.$router.replace({ name: "Home" }).catch(() => { });
        const returnToLogin = () => {
            window.location.href = 'https://dsspoc.azurewebsites.net/';
        };
        return {
            returnToLogin
        };
    }
});
